<template>
  <div class="payment-card" :class="{ removing: isRemoving }">
    <i class="card-icon" :class="iconName" />
    <span class="details">
      {{ $t('Expiry') }} {{ card.expMonth }}/{{ card.expYear }}
      {{ $t('(ending in {last4})', { last4: card.last4.toLowerCase() }) }}
      <span v-if="!card.canDelete" class="card-note">
        {{ $t('There is a future payment due on this card.') }}
      </span>
    </span>
    <delete-button-with-prompt
      v-if="card.canDelete"
      :hash="card.last4.toLowerCase()"
      class="remove-card-btn"
      @delete="remove()"
    >
      <translate>Are you sure you want to remove this card?</translate>
    </delete-button-with-prompt>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { PaymentCard } from '../schema'

@Component
class UserStoredCard extends Vue {
  @Prop({ required: true })
  card: PaymentCard

  @Prop({ default: false })
  isRemoving: boolean

  get iconName() {
    return this.card.brand.toLowerCase()
  }

  remove() {
    this.$emit('remove')
  }
}

export default toNative(UserStoredCard)
</script>

<style scoped>
@import url('~/assets/css/payment-cards.css');

.payment-card {
  font-size: var(--body);
  padding: 0.6em 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.card-note {
  display: block;
  font-size: smaller;
  color: var(--colour-text-light);
  padding: 0.25em 0 0 0;
}

.card:last-of-type {
  border: none;
}

.card.removing {
  opacity: 0.5;
  pointer-events: none;
  filter: grayscale(1);
}

.card .value,
.card label {
  flex: none;
  flex-grow: 0;
}

.card label {
  flex-grow: 1;
  color: var(--colour-text-default);
  font-size: 1em;
}

.card-no {
  display: block;
  font-size: small;
}

.card-icon {
  width: 2.5em;
  height: 2em;
  margin: 0.3em 1em 0 0;
  flex: none;
  background-image: url('~/assets/payment-cards/generic.svg');
  background-repeat: no-repeat;
}

.remove-card-btn {
  border: none;
  box-shadow: none;
  justify-self: flex-end;
  margin-left: auto;
}

.remove-card-btn :deep(.delete-icon) {
  width: 1.4em;
  opacity: 0.75;
}
</style>
